import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { isPermissionDenied, notifyPermissionDenied } from '../core/handleCallableError';

export const makeOffer = async (offerData) => {
  try {
    const makeOfferFunction = httpsCallable(functions, 'makeOfferNewV2');
    const result = await makeOfferFunction(offerData);

    if (result.data.success === true || result.data.success === 'yes') {
      return { success: 'yes', message: 'Oferta enviada' };
    } else {
      console.error('Error al realizar la oferta:', result.data.message);
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error al llamar a la función de Firebase:', error);
    if (isPermissionDenied(error)) { notifyPermissionDenied(error); throw error; }
    return { success: 'no', message: error.message };
  }
};

export const fastWin = async (offerData) => {
  try {
    const makeOfferFunction = httpsCallable(functions, 'makeInmediateWinNewV2');
    const result = await makeOfferFunction(offerData);

    if (result.data.success === true || result.data.success === 'yes') {
      return { success: 'yes', message: 'Compra enviada' };
    } else {
      console.error('Error al realizar la compra:', result.data.message);
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error al llamar a la función de Firebase:', error);
    if (isPermissionDenied(error)) { notifyPermissionDenied(error); throw error; }
    return { success: 'no', message: error.message };
  }
};
